// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"6fba8743","455":"921adb6d","977":"0329bae5"}[chunkId] + ".chunk.js";
};